/*
auto-generated by: https://github.com/react-spring/gltfjsx
*/

import * as THREE from 'three'
import { Color } from 'three';
import React, { useRef, useState, useEffect } from 'react'
import { useLoader, useFrame } from 'react-three-fiber'
import { GLTFLoader, GLTF } from 'three/examples/jsm/loaders/GLTFLoader'

type Props = {
  isSelected: boolean;
}

type GLTFResult = GLTF & {
  nodes: {
    Male_LowPoly_v001Male_LoPoly: THREE.SkinnedMesh
    QuickRigCharacter_Hips: THREE.Bone
  }
  materials: {
    Male_glTF: THREE.MeshStandardMaterial
  }
}

type ActionName = 'Idle_01'
type GLTFActions = Record<ActionName, THREE.AnimationAction>

export default function Model(props: Props & JSX.IntrinsicElements['group']) {
  const group = useRef<THREE.Group>()
  const { nodes, materials, animations } = useLoader<GLTFResult>(GLTFLoader, '/assets/Male/Poses/MaleFoiIdle/M_FOI_Idle.gltf')

  const actions = useRef<GLTFActions>()
  const [mixer] = useState(() => new THREE.AnimationMixer(nodes.Male_LowPoly_v001Male_LoPoly))
  useFrame((state, delta) => mixer.update(delta))
  useEffect(() => {
    actions.current = {
      Idle_01: mixer.clipAction(animations[0], group.current),
    };

    actions.current.Idle_01.play();

    return () => animations.forEach((clip) => mixer.uncacheClip(clip))
  }, [animations, mixer]);

  // Custom shader if selected
  if (props.isSelected) {
    materials.Male_glTF.opacity = 0.85;
    materials.Male_glTF.color = new Color(0.807, 0.37, 0.136);
  } else {
    materials.Male_glTF.opacity = 1;
    materials.Male_glTF.color = new Color(1, 1, 1);
  }

  return (
    <group name="Character Male FOI 02" ref={group} {...props} dispose={null}>
      <primitive object={nodes.QuickRigCharacter_Hips} />
      <skinnedMesh
        castShadow
        material={materials.Male_glTF}
        geometry={nodes.Male_LowPoly_v001Male_LoPoly.geometry}
        skeleton={nodes.Male_LowPoly_v001Male_LoPoly.skeleton}
      />
    </group>
  )
}
